import View from './view.js';
import React, { useRef } from 'react';

export default function Logic() {
  let contentRef = useRef();
  return <View contentRef={contentRef} />;
}
